import React from "react";

const GridView = ({ children }) => {
  return <div className="sim-list">{children}</div>;
};

export default GridView;
